import React from "react";
import { IconNormal } from "../../../widget/common/ui/Icon";
import AppTheme from "../../app_config/AppTheme";
import { useDispatch } from "react-redux";
import { appplyActionImage } from "../../../libraries/state_reducers/service/ImageEditorReducer";

const ImageEditorActions = () => {
  const dispatch = useDispatch();

  const handleSubmit = () => {
    dispatch(appplyActionImage(true));
  };

  return (
    <>
      <IconNormal
        name="check"
        size={30}
        color={AppTheme.themeFont}
        handleClick={() => handleSubmit()}
      />
    </>
  );
};

export default ImageEditorActions;
